import useOnClickOutside from 'hooks/useOnClickOutside';
import PropTypes from 'prop-types';
import { useEffect, useRef, useState } from 'react';

TagifyInput.propTypes = {
  name: PropTypes.string.isRequired,
  placeholder: PropTypes.string,
  tagifyDataWhiteList: PropTypes.array,
  tagifyDataBlackList: PropTypes.array,
  value: PropTypes.array,
  onChange: PropTypes.func,
};

function TagifyInput({
  tagifyDataWhiteList = [],
  tagifyDataBlackList = [],
  value = [],
  onChange,
  placeholder,
  name,
}) {
  // MARK: ---- PROPERTIES ----
  const [tagifyDataList, setTagifyDataList] = useState([]);
  useEffect(() => {
    setTagifyDataList(value);
  }, [value]);
  const [focus, setFocus] = useState(false);
  const refView = useRef(null);
  useOnClickOutside(refView, () => {
    setFocus(false);
  });

  return (
    <div className="position-relative" ref={refView}>
      <div
        className={`d-flex align-items-center flex-wrap gap-2 form-control px-4 py-0 h-auto py-2 ${
          focus ? 'border-success' : ''
        }`}
        onClick={() => {
          setFocus(true);
        }}
      >
        {tagifyDataList.map((item, index) => {
          return (
            <div
              key={`tagify_value_${index}`}
              className="bg-light-dark px-3 py-1 d-flex align-items-center gap-2"
              style={{ borderRadius: '5px' }}
            >
              <span>{item}</span>
              <span
                className="cursor-pointer"
                onClick={() => {
                  const newValue = tagifyDataList.filter((tag) => tag !== item);
                  setTagifyDataList(newValue);
                  if (onChange) onChange(newValue);
                }}
              >
                <i className="fa-regular fa-times mt-1 text-hover-dark"></i>
              </span>
            </div>
          );
        })}
        {/* placeholder */}
        <span className="text-dark-50 py-1">{placeholder}...</span>
      </div>
      {focus && (
        <div
          className="bg-white shadow py-2 position-absolute w-100"
          style={{
            borderRadius: '5px',
          }}
        >
          {_.difference(tagifyDataWhiteList, tagifyDataList).map((tag, index) => {
            return (
              <a
                key={`tagify_${index}`}
                className="dropdown-item px-5"
                href="#"
                onClick={(e) => {
                  e.preventDefault();
                  const newValue = [...tagifyDataList, tag];
                  setTagifyDataList(newValue);
                  if (onChange) onChange(newValue);
                }}
              >
                <div className="flex-grow-1 d-flex gap-2">
                  <span>{tag}</span>
                </div>
              </a>
            );
          })}
        </div>
      )}
    </div>
  );
}

export default TagifyInput;
